export const MESSAGING_ENDPOINTS = {
  MESSAGE_GROUPS_LIST: '/app/v1/message-groups/',
  MESSAGE_GROUP_DETAIL: (id: number) => `/app/v1/message-groups/${id}/`,
  MESSAGE_GROUP_MEMBERS: '/app/v1/message-group-members/',
  MESSAGE_GROUP_MEMBER_DETAIL: (memberId: number) =>
    `/app/v1/message-group-members/${memberId}/`,
  EXTENSIONS: '/app/v1/extensions/',
  PHONE_NUMBERS_LIST: '/app/v1/phone-numbers/',
} as const
